// Field constants — must stay in sync with TacticEngine.js (2D editor)
export const COURT_W    = 18;
export const COURT_H    = 30;
export const GOAL_W_2D  = 4;     // goal width in the 2D editor (tactic coordinates)
export const GOAL_W     = GOAL_W_2D * 0.5;   // 3D goal is narrower for realistic proportions
export const GOAL_H     = 1.2;   // net depth (2D "height" of the goal box)
export const GOAL_INSET = 3.5;
export const HALF_W     = COURT_W / 2;
export const HALF_H     = COURT_H / 2;
export const GOAL_LINE_Y = HALF_H - GOAL_INSET;   // goal mouth sits on this line

export const CORNER_R   = 2;      // rounded rink corners
export const CREASE_R   = 3;
export const BOARD_H    = 0.72;
export const GLASS_H    = 1.15;
export const GOAL_POST_H = 1.15;  // crossbar height

export const PASS_DURATION  = 0.5;
export const SHOOT_DURATION = 0.8;

export const PUCK_R = 0.13;
export const PUCK_H = 0.06;
